import { FunctionComponent, useCallback } from "react";
import { LocationIcon } from "@icons/LocationIcon";
import { colors } from "../../../ui-kit/ConfigProvider/ConfigProvider";
import { Place } from "@dto/Place";
import { Event } from "@dto/Event";
import { useAppDispatch } from "@store/store";
import { setSelectedEntityAction } from "@store/map/mapReducer";
import { useWindowSize } from "@hooks/useWindowSize/useWindowSize";
import { useNavigate } from "@hooks/useNavigate/useNavigate";
import { useLocation } from "react-router";

import "./LocationLink.css";

interface LocationLinkProps {
  entity: Place | Event;
}

const LocationLink: FunctionComponent<LocationLinkProps> = ({ entity }) => {
  const dispatch = useAppDispatch();
  const { isMobile } = useWindowSize();
  const navigate = useNavigate();
  const location = useLocation();

  const handlePress = useCallback(() => {
    dispatch(setSelectedEntityAction({ entity, type: entity.type }));
    if (isMobile) {
      navigate(location.pathname + "?view=map");
    }
  }, [dispatch, entity, isMobile, location.pathname, navigate]);

  if (!entity.location) {
    return <></>;
  }

  return (
    <div className="location-link">
      <LocationIcon color={colors.primary60} />
      <a className="location-name" onClick={handlePress}>
        {entity.location.address}
      </a>
    </div>
  );
};

export { LocationLink };
